import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { UploadPage } from "./pages/UploadPage";
import { EditorPage } from "./pages/EditorPage";
import { TemplateSelector } from "./pages/TemplateSelector";
import { MockupGallery } from "./pages/MockupGallery";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

type Tab = "upload" | "editor" | "gallery";

function App() {
  const [activeTab, setActiveTab] = useState<Tab>("upload");

  return (
    <QueryClientProvider client={queryClient}>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-bold text-blue-600">
                POD Mockup Generator
              </h1>
              <nav className="flex gap-1 bg-gray-100 rounded-lg p-1">
                {[
                  { key: "upload" as Tab, label: "1. 上傳" },
                  { key: "editor" as Tab, label: "2. 編輯" },
                  { key: "gallery" as Tab, label: "3. 結果" },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`
                      px-4 py-2 rounded-md text-sm font-medium transition-all
                      ${activeTab === tab.key
                        ? "bg-white text-blue-600 shadow-sm"
                        : "text-gray-600 hover:text-gray-900"
                      }
                    `}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-4 py-8">
          {activeTab === "upload" && (
            <div className="max-w-2xl mx-auto">
              <UploadPage onComplete={() => setActiveTab("editor")} />
            </div>
          )}

          {activeTab === "editor" && (
            <div className="space-y-8">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                <div className="lg:col-span-1">
                  <TemplateSelector />
                </div>
                <div className="lg:col-span-3">
                  <EditorPage />
                </div>
              </div>
            </div>
          )}

          {activeTab === "gallery" && (
            <MockupGallery />
          )}
        </main>

        <footer className="border-t border-gray-200 bg-white mt-20">
          <div className="max-w-7xl mx-auto px-4 py-6 text-center text-sm text-gray-500">
            POD Mockup Generator · Powered by Cloudflare + VPS
          </div>
        </footer>
      </div>
    </QueryClientProvider>
  );
}

export default App;
